import { render, staticRenderFns } from "./OCRSubmitted.vue?vue&type=template&id=171d8c6c&scoped=true"
import script from "./OCRSubmitted.vue?vue&type=script&lang=js"
export * from "./OCRSubmitted.vue?vue&type=script&lang=js"
import style0 from "./OCRSubmitted.vue?vue&type=style&index=0&id=171d8c6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "171d8c6c",
  null
  
)

export default component.exports